import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://jpobxeskiuiabcunpuxl.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impwb2J4ZXNraXVpYWJjdW5wdXhsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI5Mzc5OTgsImV4cCI6MjA1ODUxMzk5OH0.OaMEx9wFTcQSXmzBZ5ULL5tBJM0qQHG9cXDRN8BQY6E';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Save a note
export const saveNote = async (userId, content, title = 'Untitled') => {
  try {
    // Validate inputs
    if (!userId) throw new Error('User ID is required');
    if (!content) throw new Error('Content is required');
    
    // Insert the note
    const { data, error } = await supabase
      .from('notes')
      .insert([{ 
        user_id: userId, 
        content, 
        title,
        created_at: new Date().toISOString() 
      }]);

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving note:', error);
    throw error;
  }
};

// Get all notes for a user
export const getNotes = async (userId) => {
  try {
    if (!userId) throw new Error('User ID is required');
    
    const { data, error } = await supabase
      .from('notes')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching notes:', error);
    throw error;
  }
};

// Get a single note by ID
export const getNoteById = async (noteId, userId) => {
  try {
    if (!noteId) throw new Error('Note ID is required');
    if (!userId) throw new Error('User ID is required');
    
    const { data, error } = await supabase
      .from('notes')
      .select('*')
      .eq('id', noteId)
      .eq('user_id', userId)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching note by ID:', error);
    throw error;
  }
};

// Update a note
export const updateNote = async (noteId, updates, userId) => {
  try {
    if (!noteId) throw new Error('Note ID is required');
    if (!userId) throw new Error('User ID is required');
    if (!updates) throw new Error('Updates object is required');
    
    // Add updated_at timestamp
    updates.updated_at = new Date().toISOString();
    
    const { data, error } = await supabase
      .from('notes')
      .update(updates)
      .eq('id', noteId)
      .eq('user_id', userId); // Ensure user can only update their own notes

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error updating note:', error);
    throw error;
  }
};

// Delete a note
export const deleteNote = async (noteId, userId) => {
  try {
    if (!noteId) throw new Error('Note ID is required');
    if (!userId) throw new Error('User ID is required');
    
    const { data, error } = await supabase
      .from('notes')
      .delete()
      .eq('id', noteId)
      .eq('user_id', userId); // Ensure user can only delete their own notes

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error deleting note:', error);
    throw error;
  }
};